import React, { ReactNode } from 'react';

type Props = {
  to: string;
  children: ReactNode;
  onClick?: Function;
};

export default function TextLinkWrapper({ to, children, onClick }: Props) {
  return (
    <a href={to} onClick={() => onClick && onClick()}>
      {children}
    </a>
  );
}
